import "./index.css";
import { useSession } from "./auth";
import { Login } from "./pages/Login";
import { useHashRoute } from "./router";
import { renderRoute } from "./routes";
import { AppShell } from "./shell/AppShell";
import { Spinner } from "./ui/Spinner";

export function App() {
	const route = useHashRoute();
	const status = useSession();

	// The session check is one request against a local server, so this is a
	// blink rather than a loading state — but rendering the shell first would
	// fire every page's fetches only to have them 401.
	if (status === "unknown") {
		return (
			<div className="flex min-h-screen items-center justify-center bg-ground">
				<Spinner size={20} />
			</div>
		);
	}

	if (status === "out") return <Login />;

	return <AppShell current={route.path}>{renderRoute(route.path)}</AppShell>;
}

export default App;
